<div class="character-item-cast-list-container">
  <div class="section-header">角色列表</div>
  <div class="chara-list">
    @for (chara of itemsWithRelation; track chara) {
      <div class="ui segment chara-item-card">
        <div class="chara-card">
          <div class="image">
          <ui-responsive-image [src]="chara.coverImage.url" [size]="{
            width: '100%',
            ratio: chara.imageRatio,
            originalWidth: chara.coverImage.width,
            originalHeight: chara.coverImage.height
          }" [background]="chara.coverImage.dormantColor"></ui-responsive-image>
          </div>
          <div class="chara-name">{{chara.nameCn || chara.name}}</div>
          <div class="chara-name-alt">{{chara.nameCn ? chara.name : ''}}</div>
        </div>
        <div class="item-list">
          @for (item of chara.itemList; track item) {
            <div class="item">
              <div class="image">
            <ui-responsive-image [src]="item.coverImage.url" [size]="{
            width: '100%',
            ratio: item.imageRatio,
            originalWidth: item.coverImage.width,
            originalHeight: item.coverImage.height
          }" [background]="item.coverImage.dormantColor"></ui-responsive-image>
              </div>
              <div class="item-name">{{item.nameCn || item.name}}</div>
              <div class="item-alt-name">{{item.nameCn ? item.name : ''}}</div>
              <div class="extra-info">
                @if (item.type) {
                  <div class="ui mini label">{{item.type}}</div>
                }
                @if (item.subType) {
                  <div class="ui mini basic label">{{item.subType}}</div>
                }
                @if (item.publicTime) {
                  <div class="public-time">{{item.publicTime}}</div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
